import { ReactNode } from 'react';
// @mui
import { styled } from '@mui/material/styles';
// components
import Logo from '../components/Logo';
import { Box, Button, Typography } from '@mui/material';

// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  padding: theme.spacing(3, 3),
  [theme.breakpoints.down('md')]: {
    padding: '12px 20px',
    boxShadow: '0px 8px 16px rgba(145, 158, 171, 0.12)',
  },
}));

// ----------------------------------------------------------------------

const MainStyle = styled('main')(({ theme }) => ({
  background: theme.palette.background.default,
  flexGrow: 1,
  minWidth: 0, // https://github.com/kenwheeler/slick/issues/2378
}));

type Props = {
  children?: ReactNode;
  logo?: string;
  showLogo?: boolean;
  name?: string;
  hideHeader?: boolean;
};

export default function NonAuthenticatedSubscriberLayout({
  children,
  logo,
  showLogo = true,
  name,
  hideHeader,
}: Props) {
  return (
    <Box
      sx={{
        display: { lg: 'flex' },
        minHeight: { lg: 1 },
      }}
    >
      <MainStyle>
        {!hideHeader && (
          <HeaderStyle>
            {showLogo && <Logo disabledLink logoUrl={logo} name={name}/>}
          </HeaderStyle>
        )}
        {children}
        <footer>
          <Box
            component={'footer'}
            p={4}
            justifyContent={'center'}
            alignItems={'center'}
            display={'flex'}
            flexDirection={'column'}
            borderTop={'1px solid rgb(145 158 171 / 24%);'}
            sx={{ background: '#F4F9FF'}}
          >
            <Typography variant="caption">
              Powered by{' '}
              <Button href="https://www.subflow.com">
                <Logo disabledLink />
                Subflow
              </Button>
            </Typography>
          </Box>
        </footer>
      </MainStyle>
    </Box>
  );
}
